import { render, staticRenderFns } from "./ZTabsItem.vue?vue&type=template&id=d0b3537c&scoped=true&"
import script from "./ZTabsItem.vue?vue&type=script&lang=js&"
export * from "./ZTabsItem.vue?vue&type=script&lang=js&"
import style0 from "./ZTabsItem.vue?vue&type=style&index=0&id=d0b3537c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b3537c",
  null
  
)

component.options.__file = "ZTabsItem.vue"
export default component.exports